<template>
  <div class="page-content">
    <div class="headings">
      <h2 class="title title-primary">{{ location }}</h2>
      <span>|</span>
      <h2 class="title title-primary">
        {{ $t("lang.inventory.stocks.page_title_line_1") }}
      </h2>
      <span>|</span>
      <h3 class="title title-primary">
        {{ $t("lang.inventory.stocks.page_title_line_2") }}
      </h3>
    </div>
    <div class="page-header">
      <div class="boxes" v-if="!shouldLoading">
        <bx-box dark color="outline" class="col-6 col-md-auto p-1">
          <bx-value
            :label="$t('lang.inventory.stocks.box_label_2')"
            :value="number_of_stock"
            font-size="xs"
            valueColor="red"
          />
        </bx-box>
      </div>
      <skeleton-boxes :boxes="2" v-else />
    </div>

    <div class="page-main-content">
      <div class="container-fluid">
        <v-row>
          <v-col>
            <v-select
              v-model.lazy="areaSelected"
              :items="areaList"
              color="#9ac31c"
              :label="$t('lang.admin.device_form.label_select_location')"
              item-color="#9ac31c"
              item-text="description"
              item-value="id"
              outlined
            >
            </v-select>
          </v-col>
          <v-col class="d-flex justify-content-center" md="auto">
            <v-btn
              color="#9ac31c"
              class="px-10"
              style="height: 55px"
              @click="submit"
              :loading="shouldLoading"
              :disabled="shouldLoading"
              >Submit</v-btn
            >
          </v-col>
        </v-row>
        <div class="row">
          <div class="col-12">
            <bx-box
              :title="
                data.length + ' ' + $t('lang.inventory.stocks.table_box_stocks')
              "
              no-padding
              :loading="shouldLoading"
            >
              <skeleton-table :columns="7" v-if="shouldLoading" />

              <bx-table
                :data="data"
                :columns="columns"
                paginated
                v-if="!shouldLoading"
                backendPagination
                :currentPage="page"
                :perPage="itemsPerPage"
                :total="number_of_gtin"
                @search="onSearch"
                highlight-danger="quantity"
                @update:currentPage="updatePage"
              >
                <template slot-scope="props">
                  <bx-table-column field="id" centered>
                    <router-link
                      :to="`content/${props.row.id}`"
                      class="bx-link bx-link-bold"
                      >{{ props.row.id }}</router-link
                    >
                  </bx-table-column>
                  <bx-table-column centered>{{
                    props.row.quantity
                  }}</bx-table-column>
                  <bx-table-column centered>{{
                    props.row.codebar
                  }}</bx-table-column>
                  <bx-table-column centered class="py-1">
                    <div
                      class="d-flex justify-content-center align-items-center"
                    >
                      <Content :data="props.row.contents"> </Content>
                    </div>
                  </bx-table-column>
                </template>
              </bx-table>
            </bx-box>
            <v-snackbar
              :color="snackbarColor"
              v-model="snackbar"
              timeout="5000"
              top
              right
            >
              {{ snackbarText }}
            </v-snackbar>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Content from "@/components/Contents";

export default {
  components: { Content },
  name: "inventory-box-stock",
  data() {
    return {
      shouldLoading: true,
      reloadInterval: null,
      number_of_gtin: "",
      number_of_stock: "",
      columns: [],
      data: [],
      key: "inventory_stocks",
      filters: [],
      page: 1,
      itemsPerPage: process.env.VUE_APP_ITEMS_PER_PAGE,
      areaList: [],
      areaSelected: [],
      snackbar: false,
      snackbarText: "",
      snackbarColor: "#9ac31c"
    };
  },
  computed: {
    location() {
      return localStorage.getItem("location");
    }
  },
  methods: {
    onSearch(field, value) {
      this.$session.set(this.key + field, value);
      this.filters[field] = value;
      this.getData();
    },
    updatePage(p) {
      this.page = p;
      this.getData(this.locationId);
    },
    async getData() {
      try {
        let location = localStorage.getItem("location");
        let locationId = localStorage.getItem("location_id");
        if (!location || !locationId) {
          try {
            let firstLocation = await this.$api.location.search("", {
              limit: 1,
              offset: 0,
              orderBy: "id"
            });
            location = firstLocation.results[0].description;
            locationId = firstLocation.results[0].id;
          } catch (error) {
            console.log(error);
          }
        }
        this.areaList = await this.$api.area.locationAreaList(locationId);
        let area = await this.$api.location.listAreas({
          limit: 1
        });
        if (!area.data.results[0]) return;
        this.columns = [
          {
            field: "id",
            label: this.$t("lang.inventory.dashboard.table_field_2"),
            width: "120",
            centered: true
          },
          {
            field: "quantity",
            label: this.$t("lang.inventory.stocks.table_field_2"),
            width: "120",
            centered: true
          },
          {
            field: "codebar",
            label: this.$t("lang.movement.order_boxes.table_field_2"),
            centered: true
          },
          {
            field: "content",
            label: this.$t("lang.movement.order_boxes.table_field_10"),
            centered: true
          }
        ];
      } catch (error) {
        console.log(error);
      } finally {
        this.shouldLoading = false;
      }
    },
    async submit() {
      const inventories = await this.$api.area.boxstock(this.areaSelected, {});
      if (inventories.length) {
        let selected = this.areaList.find(x => x.id === this.areaSelected);
        this.number_of_stock = selected.stock;
        this.number_of_gtin = inventories.length;
        this.data = inventories.map(item => {
          return {
            id: item.id,
            quantity: item.item_count,
            codebar: item.codebar,
            contents: item.contents
          };
        });
      } else {
        this.number_of_gtin = 0;
        this.data = [];
        this.snackbarText = "No results found";
        this.snackbarColor = "red darken-2";
        this.snackbar = true;
      }
    }
  },
  async mounted() {
    // this.reloadInterval = setInterval(
    //   this.getData,
    //   process.env.VUE_APP_RELOAD_TIME
    // )
    this.getData();
  },
  beforeDestroy() {
    clearInterval(this.reloadInterval);
  }
};
</script>
